import React, { useEffect } from "react";
import logo from "../assets/img/logos/logo-white-no-bg.png";
import { Alert, Button, Snackbar } from "@mui/material";
import { IoLogoGoogle } from "react-icons/io5";
import Batteries from "../assets/loginPage.png";
import { Signup } from "../components/Auth/Signup";
import { Link } from "react-router-dom";
import { useHttp } from "../hooks/useHttp";
import { useAuth } from "../contexts/auth";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

export const SignupPage = () => {
  const { setRole, setUser } = useAuth();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { loading, sendRequest, error, clearError, data } = useHttp();

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleSignup = async (userData) => {
    try {
      userData.role = "user";
      await sendRequest("users/register", "POST", userData);
    }
    catch (error) {
      handleClick();
    }
  }

  useEffect(() => {
    if (data) {
      const user = jwtDecode(data.token);
      localStorage.setItem("token", data.token);
      setRole(user.role);
      setUser(user);
      navigate("/auth");
    }
  }, [data]);



  return (
    <div className="flex flex-row min-h-screen max-md:bg-loginPage ">
      <div className="flex flex-col items-center w-[50%] max-md:w-[100%] max-md:py-4 pt-8 gap-8 bg-white-translucent md:bg-[white] px-5 md:px-10">
        <div className="flex flex-col gap-8 w-[100%] lg:w-[400px] xl:w-[600px] self-center items-center">

          {/* <div className="max-md:self-center">
            <img src={logo} alt="ThinkClock Battery Labs" className="max-w-64" />
          </div> */}
          <h1 className="text-[#808080] text-3xl max-md:text-center mt-10 mb-5">Please Create Your Account</h1>
          {/* <Button
          fullWidth
          variant="contained"
          startIcon={<IoLogoGoogle />}
          size="large"
          sx={{
            backgroundColor: "#e8442d",
            color: "white",
            fontWeight: "900",
            "&:hover": {
              backgroundColor: "#e85d01",
            },
            "&:active": {
              backgroundColor: "#e85d01",
            },
          }}
        >
          Signup with Google
        </Button> */}
          {/* <div className="text-center">
          <p className="text-[#808080] text-xl">-OR-</p>
        </div> */}
          <div className="flex flex-col w-[90%] md:w-[60%]">
            <Signup onSubmit={handleSignup} />
          </div>
          <div className="flex flex-row items-center self-center gap-2 max-md:justify-between">
            <p className="text-[#808080]">
              Already Have An Account?</p>
            <Link to={"/"} className="text-[#e85d01]">
              <Button
                className=""
                size="small"
                variant="contained"
                sx={{
                  backgroundColor: "#e8442d",
                  fontFamily: "Bai Jamjuree",
                  color: "white",
                  fontWeight: "900",
                  "&:hover": {
                    backgroundColor: "#e85d01",
                  },
                  "&:active": {
                    backgroundColor: "#e85d01",
                  },
                }}
              >
                Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="w-[50%] max-md:hidden">
        <img src={Batteries} alt="" className="h-full" />
      </div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: "100%" }}>
          {error && (error || "An error occurred")}
        </Alert>
      </Snackbar>
    </div>
  );
};
